import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

/* Layout */
import Layout from '@/layout'

/* Router Modules */
// import componentsRouter from './modules/components'
// import chartsRouter from './modules/charts'
// import tableRouter from './modules/table'
// import nestedRouter from './modules/nested'
// import packetRouter from './modules/packet'
/**
 * Note: sub-menu only appear when route children.length >= 1
 * Detail see: https://panjiachen.github.io/vue-element-admin-site/guide/essentials/router-and-nav.html
 *
 * hidden: true                   if set true, item will not show in the sidebar(default is false)
 * alwaysShow: true               if set true, will always show the root menu
 *                                if not set alwaysShow, when item has more than one children route,
 *                                it will becomes nested mode, otherwise not show the root menu
 * redirect: noRedirect           if set noRedirect will no redirect in the breadcrumb
 * name:'router-name'             the name is used by <keep-alive> (must set!!!)
 * meta : {
    roles: ['admin','editor']    control the page roles (you can set multiple roles) madmin('8'):系统管理员,wadmin('2'|'9'):维护人员,aadmin:普通用户(APP注册用户)
    title: 'title'               the name show in sidebar and breadcrumb (recommend set)
    icon: 'svg-name'             the icon show in the sidebar
    noCache: true                if set true, the page will no be cached(default is false)
    affix: true                  if set true, the tag will affix in the tags-view
    breadcrumb: false            if set false, the item will hidden in breadcrumb(default is true)
    activeMenu: '/example/list'  if set path, the sidebar will highlight the path you set
  }
 */

/**
 * constantRoutes
 * a base page that does not have permission requirements
 * all roles can be accessed
 */
export const constantRoutes = [
  // {
  //   path: '/redirect',
  //   component: Layout,
  //   hidden: true,
  //   children: [
  //     {
  //       path: '/redirect/:path*',
  //       component: () => import('@/views/redirect/index')
  //     }
  //   ]
  // },
  {
    path: '/login',
    component: () => import('@/views/login/index'),
    hidden: true
  },
  // {
  //   path: '/auth-redirect',
  //   component: () => import('@/views/login/auth-redirect'),
  //   hidden: true
  // },
  // {
  //   path: '/404',
  //   component: () => import('@/views/error-page/404'),
  //   hidden: true
  // },
  // {
  //   path: '/401',
  //   component: () => import('@/views/error-page/401'),
  //   hidden: true
  // },
  // {
  //   path: '/',
  //   component: Layout,
  //   redirect: '/dashboard',
  //   children: [
  //     {
  //       path: 'dashboard',
  //       component: () => import('@/views/dashboard/index'),
  //       name: 'Dashboard',
  //       meta: { title: 'dashboard', icon: 'dashboard', affix: true }
  //     }
  //   ]
  // },

  {
    path: '/',
    component: Layout,
    redirect: 'user',
    hidden: true,
    children: [
      {
        path: 'user',
        component: () => import('@/views/user/appuser'),
        name: 'user',
        meta: { title: '人员管理', icon: 'user', affix: true,
        roles: ['admin', 'madmin', 'wadmin','pradmin','ciadmin'] // you can set roles in root nav
       },
      }
    ]
  },
  {
    path: '/profile',
    component: Layout,
    redirect: '/profile/index',
    hidden: true,
    children: [
      {
        path: 'index',
        component: () => import('@/views/profile/index'),
        name: 'Profile',
        meta: { title: 'profile', icon: 'user', noCache: true }
      }
    ]
  }
]

/**
 * asyncRoutes
 * the routes that need to be dynamically loaded based on user roles
 */
export const asyncRoutes = [
  // {
  //   path: '/monitor',
  //   component: Layout,
  //   // redirect: 'monitor',
  //   // hidden: true,
  //   children: [
  //     {
  //       path: 'monitor',
  //       component: () => import('@/views/auditing/monitor'),
  //       name: 'monitor',
  //       meta: { 
  //         title: '监控首页',
  //         icon: 'dashboard',
  //         affix: true,
  //         roles: ['admin', 'madmin', 'wadmin', 'aadmin'] // you can set roles in root nav
  //      },
       
  //     }
  //   ]
  // },
  // {
  //   path: '/auditing',
  //   component: Layout,
  //   children: [
  //     {
  //       path: 'checking',
  //       component: () => import('@/views/auditing/checking'),
  //       name: 'auditing',
  //       meta: {
  //         title: '审核管理',
  //         icon: 'skill',
  //         noCache: true,
  //         roles: ['admin', 'madmin', 'wadmin']//['admin', 'madmin', 'wadmin', 'aadmin']
  //       }
  //     }
  //   ]
  // },
  {
    path: '/user',
    component: Layout,
    redirect: '/user/page',
    alwaysShow: true, // will always show the root menu
    name: 'user',
    meta: {
      title: '人员管理',
      icon: 'user',
      roles: ['admin', 'madmin', 'wadmin','pradmin','ciadmin'] // you can set roles in root nav
    },
    children: [
      {
        path: 'appuser',
        component: () => import('@/views/user/appuser'),
        name: 'user',
        meta: {
          title: '微信人员注册审核管理',
          roles: ['admin', 'madmin', 'wadmin','pradmin','ciadmin'] // or you can only set roles in sub nav
        }
      },
      {
        path: 'webuser',
        component: () => import('@/views/user/webuser'),
        name: 'user',
        meta: {
          title: '省市人员管理',
          roles: ['admin', 'madmin','pradmin','ciadmin']//20230626市级管理员也可以管理省市人员管理页面，只能管理非管理员
        }
      },
      {
        path: 'webuser-survey',
        component: () => import('@/views/user/webuser-survey'),
        name: 'user',
        meta: {
          title: '勘测队人员管理',
          roles: ['admin', 'madmin','ciadmin']
        }
      }
    ]
  },
  {
    path: '/unit',
    component: Layout,
    children: [
      {
        path: 'index',
        component: () => import('@/views/unit/index'),
        name: 'unit',
        meta: {
          title: '单位管理',
          icon: 'tree',
          noCache: true,
          roles: ['admin', 'madmin'] // or you can only set roles in sub nav
        }
      }
    ]
  },
  {
    path: '/survey',
    component: Layout,
    children: [
      {
        path: 'index',
        component: () => import('@/views/survey/index'),
        name: 'survey',
        meta: {
          title: '勘测队管理',
          icon: 'peoples',
          noCache: true,
          roles: ['ciadmin'] // 20230615确认勘测队管理页面只有市级管理员有用，其他都不显示
        }
      }
    ]
  },
  {
    path: '/template',
    component: Layout,
    children: [
      {
        path: 'index',
        component: () => import('@/views/template/index'),
        name: 'template',
        meta: {
          title: '模板管理',
          icon: 'size',
          noCache: true,
          roles: ['admin', 'madmin'] // or you can only set roles in sub nav
        }
      }
    ]
  },
  {
    path: '/files',
    component: Layout,
    children: [
      {
        path: 'index',
        component: () => import('@/views/files/index'),
        name: 'files',
        meta: {
          title: '简报管理',
          icon: 'pdf',
          noCache: true,
          roles: ['admin', 'madmin','pradmin'] // or you can only set roles in sub nav
        }
      }
    ]
  },
  // {
  //   path: '/setting',
  //   component: Layout,
  //   children: [
  //     {
  //       path: 'index',
  //       component: () => import('@/views/setting/index'),
  //       name: 'setting',
  //       meta: {
  //         title: '配置管理',
  //         icon: 'form',
  //         noCache: true,
  //         roles: ['admin', 'madmin'] // or you can only set roles in sub nav
  //       }
  //     }
  //   ]
  // },
  {
    path: '/setting',
    component: Layout,
    redirect: '/setting/index',
    alwaysShow: true, // will always show the root menu
    name: 'setting',
    meta: {
      title: '配置管理',
      icon: 'form',
      roles: ['admin', 'madmin'] // you can set roles in root nav
    },
    children: [
      {
        path: 'mainpage',
        component: () => import('@/views/setting/MainpageSetting'),
        name: 'setting',
        meta: {
          title: '首页配置管理',
          roles: ['admin', 'madmin'] // or you can only set roles in sub nav
        }
      },
      {
        path: 'datafun',
        component: () => import('@/views/setting/DatafunSetting'),
        name: 'setting',
        meta: {
          title: '功能配置管理',
          roles: ['admin', 'madmin']
        }
      },
      // {
      //   path: 'index',
      //   component: () => import('@/views/setting/index'),
      //   name: 'setting',
      //   meta: {
      //     title: '首页配置管理1',
      //     roles: ['admin', 'madmin'] // or you can only set roles in sub nav
      //   }
      // },
      // {
      //   path: 'functions',
      //   component: () => import('@/views/setting/functions'),
      //   name: 'setting',
      //   meta: {
      //     title: '功能配置管理1',
      //     roles: ['admin', 'madmin']
      //   }
      // }
    ]
  },
  {
    path: '/log',
    component: Layout,
    children: [
      {
        path: 'index',
        component: () => import('@/views/log/index'),
        name: 'log',
        meta: {
          title: '系统日志',
          icon: 'message',
          noCache: true,
          roles: ['admin', 'madmin', 'wadmin','pradmin','ciadmin'] // or you can only set roles in sub nav
        }
      }
    ]
  },
  // {
  //   path: '/service',
  //   component: Layout,
  //   children: [
  //     {
  //       path: 'index',
  //       component: () => import('@/views/service/index'),
  //       name: 'service',
  //       meta: {
  //         title: '服务管理',
  //         icon: 'component',
  //         noCache: true,
  //         roles: ['admin', 'madmin'] // or you can only set roles in sub nav
  //       }
  //     }
  //   ]
  // },
  // {
  //   path: '/system',
  //   component: Layout,
  //   children: [
  //     {
  //       path: 'index',
  //       component: () => import('@/views/system/index'),
  //       name: 'system',
  //       meta: {
  //         title: '系统参数',
  //         icon: 'example',
  //         noCache: true,
  //         roles: ['admin', 'madmin'] // or you can only set roles in sub nav
  //       }
  //     }
  //   ]
  // },
  // {
  //   path: '/flood',
  //   component: Layout,
  //   redirect: '/flood/strprp',
  //   alwaysShow: true, // will always show the root menu
  //   name: 'flood',
  //   meta: {
  //     title: '测站报汛参数',
  //     icon: 'tree-table',
  //     roles: ['admin', 'madmin', 'wadmin'] // you can set roles in root nav
  //   },
  //   children: [
  //     {
  //       path: 'strprp',
  //       component: () => import('@/views/flood/strprp'),
  //       name: 'flood',
  //       meta: {
  //         title: '测站管理',
  //         roles: ['admin', 'madmin', 'wadmin'] // or you can only set roles in sub nav
  //       }
  //     },
  //     {
  //       path: 'exceedalarmriver',
  //       component: () => import('@/views/flood/exceedalarmriver'),
  //       name: 'flood',
  //       meta: {
  //         title: '河道水位超警配置',
  //         roles: ['admin', 'madmin', 'wadmin']
  //       }
  //     },
  //     {
  //       path: 'exceedalarmrsvr',
  //       component: () => import('@/views/flood/exceedalarmrsvr'),
  //       name: 'flood',
  //       meta: {
  //         title: '水库水位超警配置',
  //         roles: ['admin', 'madmin', 'wadmin']
  //       }
  //     },
  //     {
  //       path: 'alarm',
  //       component: () => import('@/views/auditing/alarm'),
  //       name: 'auditing',
  //       meta: {
  //         title: '数据告警配置',
  //         roles: ['admin', 'madmin']
  //       }
  //     }
  //   ]
  // },
  // {
  //   path: '/history',
  //   component: Layout,
  //   redirect: '/history/packet',
  //   alwaysShow: true, // will always show the root menu
  //   name: 'packet',
  //   meta: {
  //     title: '报文历史',
  //     icon: 'bug',
  //     noCache: true,
  //     roles: ['admin', 'madmin', 'wadmin', 'aadmin'] // you can set roles in root nav
  //   },
  //   children: [
  //     {
  //       path: 'unifiedhistory',
  //       component: () => import('@/views/packet/unifiedhistory'),
  //       name: 'packet',
  //       meta: {
  //         title: '统一历史',
  //         roles: ['admin', 'madmin', 'wadmin'] // or you can only set roles in sub nav
  //       }
  //     },
  //     {
  //       path: 'template',
  //       component: () => import('@/views/packet/history'),
  //       name: 'packet',
  //       meta: {
  //         title: '模板历史',
  //         roles: ['admin', 'madmin', 'wadmin', 'aadmin'] // or you can only set roles in sub nav
  //       }
  //     }
  //   ]
  // },
  
  // {
  //   path: '/situation',
  //   component: Layout,
  //   redirect: '/situation/monthtab',
  //   alwaysShow: true, // will always show the root menu
  //   name: 'situation',
  //   meta: {
  //     title: '水雨情实况表',
  //     icon: 'list',
  //     roles: ['admin', 'madmin', 'wadmin'] // you can set roles in root nav
  //   },
  //   children: [
  //     {
  //       path: 'daywrsit',
  //       component: () => import('@/views/situation/daywrsit'),
  //       name: 'situation',
  //       meta: {
  //         title: '水情日报',//'河道水库日统计',
  //         roles: ['admin', 'madmin', 'wadmin'] // or you can only set roles in sub nav
  //       }
  //     },
  //     {
  //       path: 'daywrsitallele',
  //       component: () => import('@/views/situation/daywrsitallele'),
  //       name: 'situation',
  //       meta: {
  //         title: '水情日报(全)',//'河道水库日统计',
  //         roles: ['admin', 'madmin', 'wadmin'] // or you can only set roles in sub nav
  //       }
  //     },
  //     {
  //       path: 'hourriversit',
  //       component: () => import('@/views/situation/hourriversit'),
  //       name: 'situation',
  //       meta: {
  //         title: '逐时河道水情值查询',
  //         roles: ['admin', 'madmin', 'wadmin'] // or you can only set roles in sub nav
  //       }
  //     },
  //     {
  //       path: 'hourrsvrsit',
  //       component: () => import('@/views/situation/hourrsvrsit'),
  //       name: 'situation',
  //       meta: {
  //         title: '逐时水库水情值查询',
  //         roles: ['admin', 'madmin', 'wadmin'] // or you can only set roles in sub nav
  //       }
  //     },
  //     {
  //       path: 'intervalsit',
  //       component: () => import('@/views/situation/intervalsit'),
  //       name: 'situation',
  //       meta: {
  //         title: '河道逐日统计',
  //         roles: ['admin', 'madmin', 'wadmin']
  //       }
  //     }
  //   ]
  // },
  // {
  //   path: '/statistic',
  //   component: Layout,
  //   redirect: '/statistic/index',
  //   alwaysShow: true, // will always show the root menu
  //   name: 'situation',
  //   meta: {
  //     title: '统计分析',
  //     icon: 'chart',
  //     roles: ['admin', 'madmin', 'wadmin'] // you can set roles in root nav
  //   },
  //   children: [
  //     {
  //       path: 'index',
  //       component: () => import('@/views/statistic/index'),
  //       name: 'statistic',
  //       meta: {
  //         title: '信息统计',
  //         //icon: 'chart',
  //         noCache: true,
  //         roles: ['admin', 'madmin', 'wadmin'] // or you can only set roles in sub nav
  //       }
  //     },
  //     {
  //       path: 'chart',
  //       component: () => import('@/views/statistic/chart'),
  //       name: 'chart',
  //       meta: {
  //         title: '图表统计',
  //         //icon: 'chart',
  //         noCache: true,
  //         roles: ['admin', 'madmin', 'wadmin'] // or you can only set roles in sub nav
  //       }
  //     },
  //   ]
  // },
  /** when your routing map is too long, you can split it into small modules **/
  // packetRouter,
  // 404 page must be placed at the end !!!
  { path: '*', redirect: '/404', hidden: true }
]

const createRouter = () => new Router({
  // mode: 'history', // require service support
  scrollBehavior: () => ({ y: 0 }),
  routes:constantRoutes //constantRoutes.concat(asyncRoutes) //
})

const router = createRouter()

// Detail see: https://github.com/vuejs/vue-router/issues/1234#issuecomment-357941465
export function resetRouter() {
  const newRouter = createRouter()
  router.matcher = newRouter.matcher // reset router
}

export default router
